//*******************************************************
import {  Component,  
          ChangeDetectorRef,
          ViewChild,
          LOCALE_ID, 
        }                     from '@angular/core';

import { FormatWidth, formatDate, getLocaleDateFormat }     from '@angular/common';

import { DatePipe } from '@angular/common';

import { Observable, Subscription }       from 'rxjs';
//*******************************************************
// Router
import { Router, ActivatedRoute }         from '@angular/router';
//*******************************************************
// Firestore 
import { firestorecontrol }               from "../../appfirestore/app.firestore";
//*******************************************************
// Devexpress Components
import {  DxChartComponent,
          DxGanttComponent }              from 'devextreme-angular';
//*******************************************************
// Functions
import { appfunctions  }                  from '../../functions/app.functions';
//*******************************************************
// Field Definitions
import  { 
            participantcommonfield,
            gantttask,
            taskdashboard,
            rangebartask,
            dependency,
            rangebartaskprogress
        }   from '../../appfirestore/app.fields';
//*******************************************************
@Component(
            {
              selector: 'app-comtodolistsnapshot',
              templateUrl: './comtodolistsnapshot.component.html',
              styleUrls: ['./comtodolistsnapshot.component.scss']
            }
          )
//*******************************************************
export class ComtodolistsnapshotComponent 
{
    //*******************************************************
    eventid: string = '';
    formheight: number = 0;

    @ViewChild('taskrangebarchart') BarChart: DxChartComponent;

    @ViewChild('gridtodotask') gantttodo: DxGanttComponent;
  //  @ViewChild(DxGanttComponent, { static: false }) gantttodo: DxGanttComponent;

    subscriptiontodo: Subscription;
    subscriptiontodolist: gantttask[];
    
    // GanntTask-Singular
    subscriptiontodosingular: Subscription;
    subscriptiontodolistsingular: gantttask[] = []

    subscriptiontododependency: Subscription;
    subscriptiontodolistdependencylist: dependency[];

    // eventparticipantcommon
    subscriptioneventparticipantcommon: Subscription;
    subscriptioneventparticipantlistcommon: participantcommonfield[];

    rangetododetails: Array<taskdashboard> = []; // Empty Array
    rangetodobarchart: Array<rangebartask> = []; // Empty Array
   // rangetodobarchart: Array<rangebartaskprogress> = []; // Empty Array

    eventdate: Date = new Date(2023, 11, 5)
    eventdatename: string = 'Event Date:';

    currentdate: Date = new Date();
    currentdatetext: string = 'Event Date:' +  this.datePipe.transform( new Date(), "dd-MMM-yy")

    charttooltip: boolean = false;

    dateformat: string;

    taskmindate: Date = new Date(2023, 6, 1);
    taskmaxdate: Date = new Date(2024, 3, 1);

    ganttfilterrow: boolean = true;
    ganttfiltervalue: String = '';
    ganttstartdate: Date = new Date(2023, 6, 1)
    ganttenddate: Date = new Date(2024, 12, 1)

    charttitle: string = 'Task Dashboard';
    //*******************************************************
    constructor (
                    private firestoredata: firestorecontrol, 
                    private appfunction: appfunctions,
                    private datePipe: DatePipe,
                    private ref: ChangeDetectorRef,
                    private _Activatedroute:ActivatedRoute
                )
      { 
        this.customizeText = this.customizeText.bind(this);
        this.customizeTooltip = this.customizeTooltip.bind(this);
        this.customizeargumentText= this.customizeargumentText.bind(this);
        
        this.onOptionChanged  = this.onOptionChanged.bind(this);
       
      }
    //*******************************************************
    ngOnInit(): void 
      {
          //--------------------------------------------------------------------------------------------
          // EventId
          this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
          // Form Height
          this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
          //--------------------------------------------------------------------------------------------
          this.firestoredata.loadeventparticipantcommon( this.eventid );

          this.subscriptioneventparticipantcommon = this.firestoredata.geteventparticipantcommon().subscribe
            ( items => 
              { 
                this.subscriptioneventparticipantlistcommon = items;

                if ( this.subscriptioneventparticipantlistcommon.length > 0 )
                  {
                    this.eventdate      = new Date(Date.parse(this.subscriptioneventparticipantlistcommon[0].eventdatestring));
                    this.eventdatename  = 'Event Date:' + this.datePipe.transform(this.eventdate, "dd-MMM-yy")
                    
                  }
                }
            )
          //--------------------------------------------------------------------------------------------
          //this.build_task_dashboard();

          setTimeout( () => {
                              // console.log( '1') 
                              this.BarChart.instance.beginUpdate(); 
                  //                     //  this.build_appointment_dashboard();
                            },500
                      )

          // Builds Data Starts at 1.00 Second
          setTimeout( () => {
                            //  console.log( '2') 
                              this.build_task_dashboard();
                            },1000
                    )

          // Unlocks Chart at 2 sec
          setTimeout( () => {
                              // console.log( '3') 
                              this.BarChart.instance.endUpdate();

                            },2000
                    )
          //--------------------------------------------------------------------------------------------
          const shortDateFormat = getLocaleDateFormat('en-AU' , FormatWidth.Short);
          this.dateformat = shortDateFormat; // d/M/yy
      }
    //*******************************************************  
    ngOnDestroy() 
      {

        if (typeof this.subscriptioneventparticipantcommon != 'undefined'  )
          {
            this.subscriptioneventparticipantcommon.unsubscribe()
          }

        if (typeof this.subscriptiontodo != 'undefined'  )
          {
            this.subscriptiontodo.unsubscribe()
          }

        if (typeof this.subscriptiontodosingular != 'undefined'  )
          {
            this.subscriptiontodosingular.unsubscribe()
          }
      }
   //*******************************************************
    ngAfterViewInit() 
      {
        this.ref.detectChanges();
      }
    //*******************************************************
    build_task_dashboard()  
      {
        var timespandesc: string;
        var sdate: Date;
        var edate: Date;
        //--------------------------------------------------------------------------------------------
        // Establish Connection to event -> task table
        this.firestoredata.loadtaskgantt( this.eventid, 5, '' );

        this.subscriptiontodo = this.firestoredata.geteventtaskgantt().subscribe
          ( items => 
            { 
              this.subscriptiontodolist = items;
              this.rangetododetails           = [];
              this.rangetodobarchart          = [];

              if ( this.subscriptiontodolist.length > 0 ) 
                {
               //   console.log( this.subscriptiontodolist.length )
                  for (let i = 0; i < this.subscriptiontodolist.length; i++) 
                    {   
                      sdate = new Date(Date.parse(this.subscriptiontodolist[i].start));
                      edate = new Date(Date.parse(this.subscriptiontodolist[i].end));

                      var diff = Math.abs(sdate.getTime() - edate.getTime());
                      var diffDays = Math.ceil(diff / (1000 * 3600 * 24))+1; 

                      var progress = ( this.subscriptiontodolist[i].progress / 100 ) * diffDays
                      var progressdate = new Date(Date.parse(this.subscriptiontodolist[i].start));
                      progressdate.setDate( progressdate.getDate()+progress) 
                      
                      // console.log( this.subscriptiontodolist[i] )
                      timespandesc =  this.datePipe.transform(sdate, "dd-MMM-yy") + '<br>' + ' to ' + '<br>' +
                                      this.datePipe.transform(edate, "dd-MMM-yy") 
                      //--------------------------------------------------------------------------------------------               
                      this.rangetododetails.push
                        (
                          {
                            taskid: 'Task' + i,

                            taskiddesc: this.subscriptiontodolist[i].title,
                    
                            taskrefid: this.subscriptiontodolist[i].id,
                    
                            startdate: sdate,
                    
                            enddate: edate,
                    
                            nodays: diffDays,
                    
                            timespandesc: timespandesc,
                    
                            progress: this.subscriptiontodolist[i].progress

                          }

                        )
                      //--------------------------------------------------------------------------------------------
                      this.rangetodobarchart.push
                        (
                          {
                         //   taskdesc: 'Task' + i,
                            taskdesc: this.subscriptiontodolist[i].title,
                            
                            startdate: new Date(Date.parse(this.subscriptiontodolist[i].start)),
                            enddate:  new Date(Date.parse(this.subscriptiontodolist[i].end)),
                            progressenddate: progressdate

                          }
                        )
                      //--------------------------------------------------------------------------------------------
                    }


               //  console.log( this.rangetododetails )
                 // console.log( this.rangetodobarchart )

                  
                }
            //--------------------------------------------------------------------------------------------
            }
          )
        //--------------------------------------------------------------------------------------------
      }
    //*******************************************************
    customizeText (pointInfo: any) 
      {
     //   console.log( pointInfo )

    //    console.log( pointInfo.seriesName )
    //    console.log( pointInfo.argument )
    //    console.log( pointInfo.index )
    //    console.log( pointInfo.value )

        switch ( pointInfo.index )
          {
            case 0: 
              {
                return this.datePipe.transform( pointInfo.value, 'dd-MMM-yy' )
              }

            case 1: 
              {
                return this.datePipe.transform( pointInfo.value, 'dd-MMM-yy' )
              }

            case 2: 
              {
                return this.datePipe.transform( pointInfo.value, 'dd-MMM-yy' )
              }

            default:
              {
                return '';
              }

          }
      
      }
    //*******************************************************
    customizeargumentText( argumentevent: any )
      {
      //  console.log( argumentevent.value )
      var tasktext: String = argumentevent.valueText;  
    
      if ( tasktext.length > 20 )
        {
          tasktext = tasktext.substring(0,15) + '...';

          //  return {  text: `${tasktext}` };

        }

        return tasktext

       
      }
    //*******************************************************
    // Gantt Change
    // If the Search for Task Decription changes this will be triggerred.
    onOptionChanged( event: any)
      {
        
        if (   event.fullName  == "columns[0].filterValue" )
          {
           
            if ( this.subscriptiontodolistsingular.length == 0 )
              {
           
                this.firestoredata.loadtaskganttdependency( this.eventid )
        
                this.subscriptiontododependency = this.firestoredata.geteventtaskganttdependency().subscribe
                  ( items => 
                    { 
                      this.subscriptiontodolistdependencylist = items;
                    }
                  )


                this.firestoredata.loadtaskgantt( this.eventid, 1, '' );

                this.subscriptiontodosingular = this.firestoredata.geteventtaskgantt().subscribe
                  ( items => 
                    { 
                      this.subscriptiontodolistsingular = items;
                    }
                  )
              }

              this.ganttfiltervalue = this.ganttfiltervalue;
              this.gantttodo.instance.refresh().then( () =>  {
                                                                setTimeout( () => {
                                                                                    try {
                                                                                          

                                                                                          if (typeof this.gantttodo.instance?.getVisibleTaskKeys() != undefined )
                                                                                            {
                                                                                              const visibleTaskKeys = this.gantttodo.instance?.getVisibleTaskKeys();

                                                                                              if ( visibleTaskKeys.length > 0 )
                                                                                                {
                                                                                                 
                                                                                                  this.getMinMaxDate_Gantt_Task(); // Determine minimum and maximunm
                                                                                                  
                                                                                                }
                                                                                            }
                                                                                        } catch (error) {
                                                                                                          console.log(error);
                                                                                                        }
                                                                                  }, 
                                                                                  1000 // One Seconds
                                                                            );
                                                                  
                                                                    }
                                                                )
           
          }

      }
    //*******************************************************
    getMinMaxDate_Gantt_Task()
      {   
        // console.log( this.gantttodo.instance.getVisibleTaskKeys().length )
        var minDate: Date;
        var maxDate: Date;

        var ganttminDate: Date;
        var ganttmaxDate: Date;

       if ( this.gantttodo.instance.getVisibleTaskKeys().length > 0 )
          {
            // Current Task Keys visible on the Gannt Chart
            const ganttlist = this.gantttodo.instance.getVisibleTaskKeys()

            // Get First Array to set min and max dates
            let result = this.subscriptiontodolistsingular.find(({ id }) => id === ganttlist[0]);

            minDate = new Date(Date.parse(result.start));
            maxDate = new Date(Date.parse(result.end));

            if ( this.gantttodo.instance.getVisibleTaskKeys().length > 1 )
              {

                for (let i = 1; i < ganttlist.length; i++) 
                  {   
                    let result = this.subscriptiontodolist.find(({ id }) => id === ganttlist[i]);

                    if ( new Date(Date.parse(result.start)) < minDate) 
                      {
                        minDate = new Date(Date.parse(result.start));
                      }

                    
                    if ( new Date(Date.parse(result.end))> maxDate) 
                      {
                        maxDate = new Date(Date.parse(result.end));
                      }

                  }

              }
              
           // console.log ( minDate + '-' + maxDate)
            this.gantttodo.instance.beginUpdate();

            
            ganttminDate = new Date(  minDate.getFullYear(), minDate.getMonth(),  minDate.getDate());
            ganttminDate.setDate( minDate.getDate() - 60)

            this.ganttstartdate = ganttminDate;
   
            ganttmaxDate = new Date(  maxDate.getFullYear(), maxDate.getMonth(),  maxDate.getDate())
            ganttmaxDate.setDate( maxDate.getDate() + 60)

            this.ganttenddate = ganttmaxDate
            //   console.log ( ganttminDate + '-' + ganttmaxDate)

            this.gantttodo.instance.endUpdate();

          }

      }
    //*******************************************************
    onPointClick( event: any)
      {
     
        // Get details about relevant tasks
        const result = this.rangetododetails.find(({ taskiddesc }) => taskiddesc === event.target.data.taskdesc);

        // Get Task Description that will feed into the Gantt Module
        this.ganttfiltervalue = result.taskiddesc

      }
    //*******************************************************
    onPointHoverChanged( event: any )
    {
     // console.log( event )

      if( event.target.isHovered() ) 
        {
           //   console.log(  event.target.argument )
           event.target.showTooltip();
          // this.charttooltip = true;
        } 
      else 
        {
            event.target.hideTooltip();
         //  this.BarChart.instance.hideTooltip();
         
        }

    }
  //*******************************************************
    customizeTooltip(event: any) 
    {
  
     // console.log(  event.argument )
     // console.log(  event.seriesName )
 
      var tooltiptaskiddesc: string = '';
      var tooltiptasknodays: string;
      var tooltiptaskprogress: string;
      var tooltiptext: string;
      //--------------------------------------------------------------------------------------------
      const result = this.rangetododetails.find(({ taskiddesc }) => taskiddesc === event.argument);
      console.log( result )
      //--------------------------------------------------------------------------------------------
      switch (  event.seriesName  )
        {
          //--------------------------------------------------------------------------------------------
          case 'Series1':
            {
              tooltiptaskiddesc   = result.taskiddesc
              tooltiptasknodays   = result.nodays.toString();
              tooltiptaskprogress = result.progress.toString()

              return {  

                        html: '<div>' +
                     //   '<h4>' + tooltiptaskiddesc + '</h4>' +

                        tooltiptaskiddesc + 
                        '</div>',
                    
                        color: 'gray',          // Bankground Color
                        fontColor: 'white',     // Font Color
                        borderColor: 'black',   // Border Color
                        
                      
                      
                      
                     };

            }
          //--------------------------------------------------------------------------------------------
          case 'Series10':
            {
              tooltiptext = 'X% complete'

              return {  text: `${tooltiptext}` };

            }
          //--------------------------------------------------------------------------------------------
          default:
            {
              return null
            }
          //--------------------------------------------------------------------------------------------
        }
     
  }
//*******************************************************
onContentReady( event: any )
  {

   console.log('ssssss')

 //  this.xxxxx();
   
  }

  xxxxx()
    {
      console.log( this.gantttodo.instance.getVisibleTaskKeys() )
    }

  onSelectionChanged( event: any)
    {
      console.log( 'dssss' )

    

    }
}
